export enum CustomersRoutesEnum{
    CUSTOMERS_LIST        = 'customers-list',
    CUSTOMERS_DETAIL      = 'customers-detail',
    CUSTOMERS_USERS_LIST  = 'customers-detail-users-list',
    CUSTOMERS_USER_DETAIL = 'customers-detail-users-detail',
    CUSTOMERS_ZONES       = 'customers-detail-zones',
    CUSTOMERS_RUBRIC      = 'customers-detail-rubric',
}